import $ from 'jquery';
import _ from 'underscore';

import Application from './application';

var modifierClass = function(blockClass, modifier) {
        return blockClass + '__' + modifier;
    },
    getFieldWrapper = function(event, wrapperBlock) {
        var $field = $(event.target),
            selector = '.' + wrapperBlock;

        return $field.parents(selector).first();
    },
    setFieldFocusStyle = function(event) {
        getFieldWrapper(event, this.wrapperBlock).addClass(this.wrapperFocusClass);
    },
    resetFieldFocusStyle = function(event) {
        var wrapper = getFieldWrapper(event, this.wrapperBlock),
            prevent = $('.js-input-prevent-reset-focus:hover', wrapper);

        if (prevent.length) {
            return false;
        }

        wrapper.removeClass(this.wrapperFocusClass);
    },
    setFieldHoverStyle = function(event) {
        getFieldWrapper(event, this.wrapperBlock).addClass(this.wrapperHoverClass);
    },
    resetFieldHoverStyle = function(event) {
        getFieldWrapper(event, this.wrapperBlock).removeClass(this.wrapperHoverClass);
    },
    initializeElementsEvents = function(fields, wrapperBlock) {
        var wrapperHoverClass = modifierClass(wrapperBlock, 'hover'),
            wrapperFocusClass = modifierClass(wrapperBlock, 'focus'),
            fieldEventHandler = (function(context) {
                return function(handler) {
                    return _.bind(handler, context);
                };
            })({
                wrapperBlock: wrapperBlock,
                wrapperFocusClass: wrapperFocusClass,
                wrapperHoverClass: wrapperHoverClass
            });

        var init = function(field) {
            var $field = $(field);

            $field.focus(fieldEventHandler(setFieldFocusStyle));
            $field.blur(fieldEventHandler(resetFieldFocusStyle));
            $field.mouseenter(fieldEventHandler(setFieldHoverStyle));
            $field.mouseleave(fieldEventHandler(resetFieldHoverStyle));
        };

        _.each(fields, init);
    };
var initializeAllElementsEvents = function(context) {
    var inputElementsNotReadonlySelector = $('input:not([readonly=readonly])', context);

    initializeElementsEvents(inputElementsNotReadonlySelector, 'form-input');
    initializeElementsEvents(inputElementsNotReadonlySelector, 'input-light');
    initializeElementsEvents(inputElementsNotReadonlySelector, 'input-game');
    initializeElementsEvents($('textarea', context), 'form-textarea');
};

var setupEvents = function(options) {
    if (options.fields && options.wrapperBlock) {
        initializeElementsEvents(options.fields, options.wrapperBlock);
    } else {
        initializeAllElementsEvents(options.context);
    }
}

Application.on('ui.elements.setup-events', setupEvents);

setupEvents.init = () => {
    initializeAllElementsEvents(document);
};

export default setupEvents;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/elements_init.js